module.exports = __webpack_public_path__ + "static/media/Samantha M.864705a0.jpg";